import React, { useState, useEffect } from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
//import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import config from '../../config';
import {
  Page,
  SectionHero,
  SectionInfo,
  SectionDeafUsers,
  SectionNextBooking,
  SectionHowItWorks,
  SectionInvest,
  SectionWhyUs,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';

import facebookImage from '../../assets/signaliseFacebook-1200x630.jpg';
import twitterImage from '../../assets/signaliseTwitter-600x314.jpg';
import css from './LandingPage.module.css';
import { ensureCurrentUser } from '../../util/data';

//import FallbackPage from './FallbackPage';
//import { ASSET_NAME } from './LandingPage.duck';

export const LandingPageComponent = props => {
  //const { pageAssetsData, inProgress, error } = props;
  const {
    history,
    intl,
    location,
    scrollingDisabled,
    currentUserListing = null,
    currentUserListingFetched = false,
    currentUser,
  } = props;
  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const [isUser, setIsUser] = useState(false);
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;
  const user = ensureCurrentUser(currentUser);
  const userExists = !!currentUser;
  useEffect(() => {
    setIsUser(userExists);
  }, [currentUser]);
  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <SectionHero className={css.hero} history={history} location={location} />
          </div>

          <ul className={css.sections}>
            {isUser && (
              <li className={css.section}>
                <div className={css.sectionContent}>
                  <SectionNextBooking className={css.flex} />{' '}
                </div>
              </li>
            )}

            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionInvest
                  currentUserListing={currentUserListing}
                  currentUserListingFetched={currentUserListingFetched}
                />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionHowItWorks
                  currentUserListing={currentUserListing}
                  currentUserListingFetched={currentUserListingFetched}
                />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionWhyUs
                  currentUserListing={currentUserListing}
                  currentUserListingFetched={currentUserListingFetched}
                />
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionDeafUsers
                  currentUserListing={currentUserListing}
                  currentUserListingFetched={currentUserListingFetched}
                />
              </div>
            </li>
          </ul>
          <section className={css.infoContainer}>
            <SectionInfo className={css.info} history={history} location={location} />
          </section>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

{
  /* TODO check after merge
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  */
}


LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
  //New from merge TODO
  //pageAssetsData: object,
  //inProgress: bool,
  //error: propTypes.error,
};

const mapStateToProps = state => {
  //const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUserListing, currentUserListingFetched, currentUser } = state.user;
  return {
    //pageAssetsData,
    //inProgress,
    //error,
    scrollingDisabled: isScrollingDisabled(state),
    currentUserListing,
    currentUserListingFetched,
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(withRouter, connect(mapStateToProps), injectIntl)(LandingPageComponent);
//const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent); /*TODO NEW MERGE*/

export default LandingPage;
